import BasicInitContainer from "../../../../components/formsAndTable/tables/dataTables/basicInit";

const BasicInit = () => {
  return <BasicInitContainer />;
};

export default BasicInit;
